import z from 'zod';

export type IBAN = z.infer<typeof IBAN>;

export const IBAN = z
    .string()
    .transform((iban) => iban.replace(/\s+/g, '').toUpperCase())
    .refine(validateIBAN, { message: 'Invalid IBAN format' });

function validateIBAN(iban: string): boolean {
    if (iban.length !== 22) {
        return false;
    }

    // Move first 4 characters to the end
    const rearranged = iban.slice(4) + iban.slice(0, 4);

    // Convert letters to numbers (A=10, B=11, ..., Z=35)
    const numericString = rearranged
        .split('')
        .map((char) => {
            const code = char.charCodeAt(0);
            // Check if character is a letter (A-Z)
            if (code >= 65 && code <= 90) {
                return (code - 55).toString();
            }
            return char;
        })
        .join('');

    // Calculate MOD-97 using BigInt to avoid precision issues
    try {
        const ibanBigInt = BigInt(numericString);
        return ibanBigInt % 97n === 1n;
    } catch {
        // Returns false if the string contains invalid characters (non-alphanumeric)
        return false;
    }
}
